export default function formatProduct(input) {
  switch (input) {
    case 'name':
      return 'Tên hệ đào tạo'
    case 'acronym':
      return 'Tên viết tắt'
    case 'grade':
      return 'Khối tuyển sinh'
    case 'type':
      return 'Phân loại'
    case 'productType':
      return 'Phân loại'
    case 'status':
      return 'Trạng thái'
    case 'note':
      return 'Ghi chú'
    case 'undefined':
      return 'Chưa có'
    default:
      return input
  }
}
